/* Auto-rotating image carousel (Custom work section). */
(function () {
  'use strict';
  if (customElements.get('ll-carousel')) return;

  class LlCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.delay = parseInt(this.dataset.speed || '4', 10) * 1000;
      this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const prev = this.querySelector('[data-carousel-prev]');
      const next = this.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
      this.dots.forEach((d) => d.addEventListener('click', () => { this.go(parseInt(d.dataset.carouselDot, 10)); this.restart(); }));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.play());
      this.addEventListener('shopify:block:select', (e) => { this.stop(); this.go(this.slides.indexOf(e.target)); });
      this.addEventListener('shopify:block:deselect', () => this.play());

      let x = null;
      this.addEventListener('touchstart', (e) => { x = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x === null) return;
        const dx = e.changedTouches[0].clientX - x;
        if (Math.abs(dx) > 40) { this.go(this.index + (dx < 0 ? 1 : -1)); this.restart(); }
        x = null;
      });
      this.play();
    }
    disconnectedCallback() { this.stop(); }
    go(i) {
      const n = this.slides.length;
      if (i < 0 || Number.isNaN(i)) i = n - 1;
      if (i >= n) i = 0;
      if (i !== this.index) {
        // Keep the outgoing photo zooming while it fades, so it doesn't snap back to full size mid-transition.
        const old = this.slides[this.index];
        old.classList.add('is-leaving');
        clearTimeout(old._leaveTimer);
        old._leaveTimer = setTimeout(() => old.classList.remove('is-leaving'), 900);
      }
      const incoming = this.slides[i];
      clearTimeout(incoming._leaveTimer);
      incoming.classList.remove('is-leaving');
      this.index = i;
      this.slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    }
    play() {
      if (!this.autoplay) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), this.delay);
    }
    stop() { clearInterval(this.timer); }
    restart() { this.stop(); this.play(); }
  }
  customElements.define('ll-carousel', LlCarousel);
})();
